export default () => `${window.location.href}/`?.match(`${window.location.origin}/(.*?)/`)?.[1]
